import { useApiReadEntireCollection } from "source/shared/SessionApiResource"
import { BaseAPIRecord } from "source/shared/types"

export interface Campus extends BaseAPIRecord {
  attributes: {
    name: string
    group_count: number
  }
}

function useCampuses() {
  const url = `/groups/v2/campuses?fields[Campus]=name,group_count`
  const responses = useApiReadEntireCollection<Campus>(url)

  return responses.flatMap(({ data }) => data)
}

const hasGroupsAssigned = (campus: Campus) => campus.attributes.group_count > 0

/**
 * Two conditions determine whether to show a campus filter:
 * 1. The organization has at least two campuses.
 * 2. The organization has at least one campuses assigned to group(s).
 */
export function useAvailableCampuses() {
  const campuses = useCampuses()

  const multiCampus = campuses.length > 1
  if (!multiCampus) return []

  return campuses.filter(hasGroupsAssigned)
}
